import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Tr from "../common/table/tr";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./contratoMercadoLivreForm";
import Select from "../common/form/select";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    excluir,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    visualizarArquivo,
    buscarArquivo,
} from "./contratoMercadoLivreActions";
import { Loading } from "../common/loading/loading";
import { setError } from "../common/toast/toast";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";

function ContratoMercadoLivre(props) {
    const [state, setState] = useState({
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        setError("Acesso negado!");
        return <div />;
    }

    useEffect(() => {
        props.getUcValidarUsuarioImplantacao();
        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" && <Form onSubmit={() => {}} visualizacao />}
                {props.modoTela === "cadastro" && <Form onSubmit={props.salvar} />}
                {props.modoTela === "exclusao" && <Form excluir onSubmit={props.excluir} />}
                {props.modoTela === "lista" && lista()}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_contrato_mercado_livre_adicionar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({});
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente.filter(
                                (cliente) => props.usuarioLogado && props.usuarioLogado.administrador && props.lista.find((contrato) => contrato.id_cliente === cliente.id)
                            )}
                            label="Cliente"
                            cols="12 6 4"
                            placeholder="Selecione o Cliente"
                            isClearable={true}
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_unidade_consumidora: null,
                                });
                            }}
                        />

                        <Select
                            name="id_unidade_consumidora"
                            isClearable={true}
                            options={props.listaUnidadeConsumidora.filter((item) => {
                                props.usuarioLogado &&
                                    props.usuarioLogado.administrador &&
                                    (!props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente) &&
                                    props.lista.find((contrato) => contrato.id_unidade_consumidora === item.id);
                            })}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 4"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />
                    </Row>

                    <Table responsive>
                        <THead>
                            <NewTr>
                                <Th rowSpan="2" verticalAlign="middle" minWidth={200} sticky>
                                    Cliente
                                </Th>
                                <Th rowSpan="2" alignCenter verticalAlign="middle" minWidth={200} sticky>
                                    Unidade Consumidora
                                </Th>
                                <Th alignCenter verticalAlign="middle" width={100} sticky>
                                    Ano
                                </Th>
                                <Th alignCenter verticalAlign="middle" width={150} sticky>
                                    Valor Contratado (R$/MWh)
                                </Th>
                                <Th alignCenter verticalAlign="middle" width={150} sticky>
                                    Quantidade Contratada (kWh/mês)
                                </Th>
                                <Th alignCenter verticalAlign="middle" width={150} sticky>
                                    Flexibilidade Mínima (%)
                                </Th>
                                <Th alignCenter verticalAlign="middle" width={150} sticky>
                                    Flexibilidade Máxima (%)
                                </Th>
                                <Th rowSpan="2" alignCenter verticalAlign="middle" width={200} sticky>
                                    Arquivo Contrato
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                return (
                                    <NewTr
                                        key={item.id}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_contrato_mercado_livre_visualizar,
                                                event: async () => {
                                                    const arquivo_contrato = await buscarArquivo(item);
                                                    props.initForm({ ...item, arquivo_contrato });
                                                    props.setModoTela("visualizacao");
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !props.usuarioLogado.acesso_contrato_mercado_livre_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: async () => {
                                                    const arquivo_contrato = await buscarArquivo(item);
                                                    props.initForm({ ...item, arquivo_contrato });
                                                    props.setModoTela("cadastro");
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !props.usuarioLogado.acesso_contrato_mercado_livre_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: async () => {
                                                    const arquivo_contrato = await buscarArquivo(item);
                                                    props.initForm({ ...item, arquivo_contrato });
                                                    props.setModoTela("exclusao");
                                                },
                                            },
                                        ]}
                                    >
                                        <Td>{item.nome_cliente}</Td>
                                        <Td alignCenter>{item.nome_unidade_consumidora}</Td>
                                        <Td colSpan="5">
                                            <Table responsive>
                                                <TBody>
                                                    {item.anos.map((itemAno) => (
                                                        <Tr key={itemAno.id}>
                                                            <Td backgroundColor={"#F5F5F5"} alignCenter width={100}>
                                                                {itemAno.ano}
                                                            </Td>
                                                            <Td backgroundColor={"#F5F5F5"} alignCenter width={150}>
                                                                {adicionarPontosMilhar(itemAno.valor_contratado_anual)}
                                                            </Td>
                                                            <Td backgroundColor={"#F5F5F5"} alignCenter width={150}>
                                                                {adicionarPontosMilhar(itemAno.quantidade_energia_contratada_mensal)}
                                                            </Td>
                                                            <Td backgroundColor={"#F5F5F5"} alignCenter width={150}>
                                                                {adicionarPontosMilhar(itemAno.flexibilidade_minima)}
                                                            </Td>
                                                            <Td backgroundColor={"#F5F5F5"} alignCenter width={150}>
                                                                {adicionarPontosMilhar(itemAno.flexibilidade_maxima)}
                                                            </Td>
                                                        </Tr>
                                                    ))}
                                                </TBody>
                                            </Table>
                                        </Td>

                                        <Td backgroundColor={"#F5F5F5"} alignCenter minWidth={50}>
                                            {item.arquivo_contrato ? (
                                                <ButtonTable
                                                    type={"primary"}
                                                    icon={"fas fa-file-pdf"}
                                                    visible={true}
                                                    disabled={false}
                                                    event={() => {
                                                        props.visualizarArquivo(item.id, `contrato_mercado_livre_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}`);
                                                        props.setArquivoPDF();
                                                    }}
                                                />
                                            ) : (
                                                " - "
                                            )}
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.contratoMercadoLivre.modoTela,
    formularioValues: getFormValues("contratoMercadoLivreForm")(state),
    aguardando: state.contratoMercadoLivre.aguardando,
    filtro: state.contratoMercadoLivre.filtro,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.contratoMercadoLivre.lista),
    listaCliente: state.contratoMercadoLivre.listaCliente,
    listaUnidadeConsumidora: state.contratoMercadoLivre.listaUnidadeConsumidora,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setArquivoPDF,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getUcValidarUsuarioImplantacao,
            visualizarArquivo,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ContratoMercadoLivre);
